import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Card, Input, Spin, Alert } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { getPlaces } from '../services/placesService';

const { Search } = Input;

function PlaceCard({ place }) {
  return (
    <Card
      cover={
        <div style={{ position: 'relative' }}>
          <img
            alt={place.name}
            src={place.image_url || 'https://source.unsplash.com/random?place'}
            style={{ height: 200, width: '100%', objectFit: 'cover' }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(transparent, rgb(0, 0, 0))',
              padding: '20px',
              paddingTop: '40px',
              color: 'white',
            }}
          >
            <Typography.Title level={5} style={{ color: 'white', margin: 0 }}>
              {place.name}
            </Typography.Title>
            {/* <Typography.Text style={{ color: 'white' }}>
              {place.category?.name}
            </Typography.Text> */}
          </div>
        </div>
      }
      bodyStyle={{ display: 'none' }}
      style={{
        height: '200px',
        cursor: 'pointer',
      }}
      onClick={() => window.open(`/places/${place.id}`, '_blank')}
    />
  );
}

function PlacesEmbed() {
  const [places, setPlaces] = useState([]);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  useEffect(() => {
    const fetchPlaces = async () => {
      try {
        const data = await getPlaces(categoryId);
        setPlaces(data);
        setFilteredPlaces(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaces();
  }, [categoryId]);

  const handleSearch = value => {
    const filtered = places.filter(
      place =>
        place.name.toLowerCase().includes(value.toLowerCase()) ||
        place.description?.toLowerCase().includes(value.toLowerCase()) ||
        place.category?.name?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPlaces(filtered);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Search
        placeholder="Search places..."
        onChange={e => handleSearch(e.target.value)}
        style={{ marginBottom: 24 }}
      />

      <Row gutter={[16, 16]}>
        {filteredPlaces.map(place => (
          <Col key={place.id} xs={24} sm={12} md={8} lg={6}>
            <PlaceCard place={place} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default PlacesEmbed;
